module.exports = __webpack_public_path__ + "static/img/r_022.973a9a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_022.jpg
// module id = Ix54
// module chunks = 1